import { Link, Typography } from "@mui/material";
import FairUseDialog from "components/FairUseDialog/FairUseDialog";
import FixedAppBar from "components/styled/FixedAppBar";
import React, { useState } from "react";

function CopyrightStatement() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const currentYear = new Date().getFullYear();

  return (
    <FixedAppBar
      position="fixed"
      sx={{
        height: "4rem",
      }}
      component="footer"
    >
      <Typography
        variant="body1"
        sx={{
          paddingRight: "5px",
        }}
      >
        COMP&trade;, {currentYear} &copy;{" "}
      </Typography>
      <Link
        component="button"
        variant="body1"
        color="whitePrimary.main"
        onClick={handleOpen}
      >
        Fair Use Statement
      </Link>
      <FairUseDialog open={open} handleClose={handleClose} />
    </FixedAppBar>
  );
}

export default CopyrightStatement;
